var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongSleeveTshirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1399 13.8789L34.2099 11.3449C34.1729 11.3199 34.1419 11.2869 34.1279 11.2399C34.0089 10.8279 33.4639 9.9819 32.7799 9.5699C32.0939 9.1579 31.0319 9.0669 31.0319 9.0669L31.1019 9.0459H27.6569C27.2939 10.7269 25.8029 11.9879 24.0119 11.9879C22.2219 11.9879 20.7309 10.7269 20.3679 9.0459H16.9909L17.0109 9.0669C17.0109 9.0669 15.9699 9.0329 15.0959 9.6829C14.2219 10.3329 13.9689 11.0589 13.8999 11.2829C13.8979 11.2919 13.8789 11.2889 13.8709 11.2949L13.7399 11.6529V11.6539L4.33594 37.4039L9.75294 38.8549L12.5949 31.0549L12.5959 31.0509L13.7399 27.9109V28.0139L16.6609 20.2609V36.2289H31.5079L31.5569 20.2029L35.5979 31.5829L38.1469 38.5819L38.2469 38.9539L43.6649 37.5029L35.1399 13.8789Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongSleeveTshirt);
export default __webpack_public_path__ + "static/media/long_sleeve_tshirt.0900959b777eedbcf91cb1da85b92720.svg";
export { ForwardRef as ReactComponent };